module.exports = __webpack_public_path__ + "static/media/basic.72f2f380.png";